import { Component, Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';

/**
 * Create/edit editor for a transaction fee pricing mode - whether amounts quoted for a
 * payment entity target type (e.g. HotelReservationParkingPermit) are inclusive or
 * exclusive of the organization's transaction fees.
 */
@Component({
    selector: 'app-edittransactionfeepricingmode',
    templateUrl: './edittransactionfeepricingmode.component.html',
    standalone: false
})
export class EdittransactionfeepricingmodeComponent extends ModelEditor {

  public TargetTypes: any[] | null = null;

  constructor(private injector: Injector) {
    super("payments/transactionbreakdown/pricingmodes", injector);
    this.api.Get<any[]>("common/modeltypes/PaymentEntity").then(result => this.TargetTypes = result);
  }

  public override DefaultModel(): any {
    return {
      TargetType: "",
      PricingMode: 0
    };
  }

  public override AfterModelLoaded(): void {
  }

  public override BeforeSave(): boolean | void {
  }

  public override Validators(): any {
    return {
      "TargetType": [Validators.required]
    };
  }
}
